(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
    
  if (!window.AnnouncementBarCopyCode) {
    window.AnnouncementBarCopyCode = (() => {
      const copyText = async (text) => {
        try {
          if (navigator.clipboard && window.isSecureContext) {
            await navigator.clipboard.writeText(text);
            return true;
          }
        } catch (error) {
          // fall through to the textarea fallback
        }

        const textarea = document.createElement('textarea');
        textarea.value = text;
        textarea.setAttribute('readonly', '');
        textarea.style.position = 'fixed';
        textarea.style.top = '-1000px';
        textarea.style.opacity = '0';
        document.body.appendChild(textarea);
        textarea.select();
        textarea.setSelectionRange(0, text.length);
        let copied = false;
        try {
          copied = document.execCommand('copy');
        } catch (error) {
          copied = false;
        }
        textarea.remove();
        return copied;
      };

      document.addEventListener('click', async (event) => {
        const button = event.target.closest('[data-announcement-copy]');
        if (!button) return;

        event.preventDefault();
        event.stopPropagation();

        const code = button.dataset.announcementCopy;
        if (!code) return;

        const label = button.querySelector('[data-copy-label]');
        const status = button.parentElement && button.parentElement.querySelector('[data-copy-status]');
        if (!button.dataset.originalLabel && label) button.dataset.originalLabel = label.textContent;

        // Keep the width while the label changes so the bar does not jump.
        button.style.minWidth = `${button.offsetWidth}px`;

        const copied = await copyText(code);
        // If the browser blocks the clipboard, show the code so it can be copied by hand.
        const feedback = copied ? button.dataset.copiedLabel || code : code;
        if (label) label.textContent = feedback;
        if (status) status.textContent = feedback;
        button.classList.add('is-copied');

        window.clearTimeout(Number(button.dataset.copyTimer || 0));
        button.dataset.copyTimer = String(
          window.setTimeout(() => {
            if (label) label.textContent = button.dataset.originalLabel || code;
            if (status) status.textContent = '';
            button.classList.remove('is-copied');
            button.style.minWidth = '';
          }, 2500)
        );
      });

      return { copyText };
    })();
  }

  if (!window.AnnouncementBarCountdown) {
    window.AnnouncementBarCountdown = (() => {
      // Offset (ms) between a time zone's wall clock and UTC at a given instant.
      const getTimeZoneOffset = (timestamp, timeZone) => {
        const parts = new Intl.DateTimeFormat('en-US', {
          timeZone,
          hourCycle: 'h23',
          year: 'numeric',
          month: '2-digit',
          day: '2-digit',
          hour: '2-digit',
          minute: '2-digit',
          second: '2-digit',
        }).formatToParts(new Date(timestamp));
        const map = {};
        parts.forEach((part) => {
          map[part.type] = part.value;
        });
        const wallClockAsUtc = Date.UTC(
          Number(map.year),
          Number(map.month) - 1,
          Number(map.day),
          Number(map.hour),
          Number(map.minute),
          Number(map.second)
        );
        return wallClockAsUtc - timestamp;
      };

      // Wall-clock date/time in an IANA time zone (e.g. Europe/Madrid) -> absolute Date. Null if the zone is invalid.
      const zonedTimeToDate = (parts, timeZone) => {
        try {
          const wallClock = Date.UTC(...parts);
          let timestamp = wallClock - getTimeZoneOffset(wallClock, timeZone);
          timestamp = wallClock - getTimeZoneOffset(timestamp, timeZone);
          return new Date(timestamp);
        } catch (error) {
          return null;
        }
      };

      const parseDateValue = (value, timeZone = '') => {
        if (!value) return null;

        const localDateMatch = value.match(/^(\d{4})-(\d{2})-(\d{2})(?:[T\s](\d{2}):(\d{2})(?::(\d{2}))?)?$/);
        if (localDateMatch) {
          const [, year, month, day, hour = '00', minute = '00', second = '00'] = localDateMatch;
          if (timeZone) {
            const zonedDate = zonedTimeToDate(
              [Number(year), Number(month) - 1, Number(day), Number(hour), Number(minute), Number(second)],
              timeZone.trim()
            );
            if (zonedDate && !Number.isNaN(zonedDate.getTime())) return zonedDate;
          }

          return new Date(
            Number(year),
            Number(month) - 1,
            Number(day),
            Number(hour),
            Number(minute),
            Number(second)
          );
        }

        const parsedDate = new Date(value);
        if (Number.isNaN(parsedDate.getTime())) return null;
        return parsedDate;
      };

      const formatValue = (value) => String(Math.max(value, 0)).padStart(2, '0');

      const setCountdownValues = (element, remainingMilliseconds = 0) => {
        const remainingSeconds = Math.max(Math.floor(remainingMilliseconds / 1000), 0);
        const days = Math.floor(remainingSeconds / 86400);
        const hours = Math.floor((remainingSeconds % 86400) / 3600);
        const minutes = Math.floor((remainingSeconds % 3600) / 60);
        const seconds = remainingSeconds % 60;

        const values = { days, hours, minutes, seconds };

        Object.entries(values).forEach(([unit, value]) => {
          const target = element.querySelector(`[data-countdown-unit="${unit}"]`);
          if (target) target.textContent = formatValue(value);
        });
      };

      const attachCountdown = (element) => {
        if (element.dataset.countdownAttached === 'true') return;

        element.dataset.countdownAttached = 'true';

        const countdownTarget = parseDateValue(element.dataset.countdownEnd || '', element.dataset.countdownTimezone || '');
        if (!countdownTarget) {
          setCountdownValues(element, 0);
          return;
        }

        const tick = () => {
          const remaining = countdownTarget.getTime() - Date.now();
          setCountdownValues(element, remaining);

          if (remaining <= 0 && element.dataset.countdownTimerId) {
            window.clearInterval(Number(element.dataset.countdownTimerId));
            delete element.dataset.countdownTimerId;
          }
        };

        tick();
        element.dataset.countdownTimerId = String(window.setInterval(tick, 1000));
      };

      const clearCountdown = (element) => {
        if (element.dataset.countdownTimerId) {
          window.clearInterval(Number(element.dataset.countdownTimerId));
          delete element.dataset.countdownTimerId;
        }

        delete element.dataset.countdownAttached;
      };

      const init = (root = document) => {
        root.querySelectorAll('[data-announcement-countdown]').forEach(attachCountdown);
      };

      document.addEventListener('shopify:section:load', (event) => {
        init(event.target);
      });

      document.addEventListener('shopify:section:unload', (event) => {
        event.target.querySelectorAll('[data-announcement-countdown]').forEach(clearCountdown);
      });

      return { init };
    })();
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        window.AnnouncementBarCountdown.init();
      },
      { once: true }
    );
  } else {
    window.AnnouncementBarCountdown.init();
  }

  if (!window.AnnouncementBarMobilePanels) {
    window.AnnouncementBarMobilePanels = (() => {
      const mobileMediaQuery = window.matchMedia('(max-width: 989px)');
      const panelOrder = ['left', 'center', 'right'];

      // Slides outside their "Show from" / "Hide from" dates are [hidden] and take no part.
      const getGroups = (root) =>
        Array.from(root.querySelectorAll('[data-mobile-panel-group]')).filter(
          (group) => !group.closest('.slideshow__slide[hidden]')
        );

      const getPanels = (group) =>
        panelOrder
          .map((panelName) => group.querySelector(`[data-mobile-panel="${panelName}"]`))
          .filter(Boolean);

      const getStates = (root) =>
        getGroups(root).flatMap((group) =>
          getPanels(group).map((panel, panelIndex) => ({
            group,
            panel,
            panelIndex,
            slide: group.closest('.slideshow__slide'),
          }))
        );

      const getDefaultStateIndex = (root) => {
        const states = getStates(root);
        if (!states.length) return -1;

        const firstGroup = states[0].group;
        const centeredIndex = states.findIndex(
          (state) => state.group === firstGroup && state.panel.dataset.mobilePanel === 'center'
        );

        return centeredIndex >= 0 ? centeredIndex : 0;
      };

      const updateNavVisibility = (root) => {
        const hasMultipleStates = getStates(root).length > 1;

        root.querySelectorAll('.announcement-bar__mobile-nav').forEach((button) => {
          button.hidden = !hasMultipleStates;
        });
      };

      const syncCountdownState = (root, group) => {
        root.classList.toggle(
          'is-mobile-countdown-active',
          Boolean(group && group.classList.contains('announcement-bar__slide-content--countdown'))
        );

        // Arrows sit outside the slides, so copy the active slide's text colour (blocks can override it).
        const slide = group && group.closest('.slideshow__slide');
        if (slide) root.style.setProperty('--announcement-nav-color', window.getComputedStyle(slide).color);
      };

      const setActiveState = (root, nextIndex, options = {}) => {
        const { syncSlide = true } = options;
        const states = getStates(root);
        if (!states.length) return;

        const normalizedIndex = ((nextIndex % states.length) + states.length) % states.length;
        const activeState = states[normalizedIndex];

        getGroups(root).forEach((group) => {
          getPanels(group).forEach((panel) => panel.classList.remove('is-mobile-active'));
        });

        activeState.panel.classList.add('is-mobile-active');
        syncCountdownState(root, activeState.group);
        root.dataset.mobilePanelStateIndex = String(normalizedIndex);

        if (syncSlide && activeState.slide) {
          const slider = activeState.slide.parentElement;
          if (slider && Math.abs(slider.scrollLeft - activeState.slide.offsetLeft) > 1) {
            root.dataset.mobilePanelSyncing = 'true';
            slider.scrollTo({
              left: activeState.slide.offsetLeft,
            });
          }
        }
      };

      const initRoot = (root) => {
        if (!root || root.dataset.mobilePanelsInitialized === 'true') return;

        const defaultStateIndex = getDefaultStateIndex(root);
        if (defaultStateIndex < 0) return;

        root.dataset.mobilePanelsInitialized = 'true';
        updateNavVisibility(root);
        setActiveState(root, defaultStateIndex, { syncSlide: false });

        root.querySelectorAll('.announcement-bar__mobile-nav').forEach((button) => {
          button.addEventListener(
            'click',
            (event) => {
              if (!mobileMediaQuery.matches) return;

              const states = getStates(root);
              if (states.length <= 1) return;

              event.preventDefault();
              event.stopImmediatePropagation();

              const currentIndex = Number(root.dataset.mobilePanelStateIndex || defaultStateIndex);
              const direction = event.currentTarget.name === 'previous' ? -1 : 1;
              setActiveState(root, currentIndex + direction);
            },
            true
          );
        });

        const slideshow = root.querySelector('slideshow-component');
        if (slideshow) {
          slideshow.addEventListener('slideChanged', (event) => {
            syncCountdownState(root, event.detail.currentElement?.querySelector('[data-mobile-panel-group]'));

            if (!mobileMediaQuery.matches) return;

            if (root.dataset.mobilePanelSyncing === 'true') {
              delete root.dataset.mobilePanelSyncing;
              return;
            }

            const activeGroup = event.detail.currentElement?.querySelector('[data-mobile-panel-group]');
            if (!activeGroup) return;

            const states = getStates(root);
            const centeredIndex = states.findIndex(
              (state) => state.group === activeGroup && state.panel.dataset.mobilePanel === 'center'
            );

            if (centeredIndex >= 0) {
              setActiveState(root, centeredIndex, { syncSlide: false });
            }
          });
        }
      };

      const init = (root = document) => {
        root.querySelectorAll('.announcement-bar-shell').forEach(initRoot);
      };

      // Called again when scheduled slides are shown or hidden.
      const refresh = (root) => {
        if (root.dataset.mobilePanelsInitialized !== 'true') {
          initRoot(root);
          return;
        }

        const defaultStateIndex = getDefaultStateIndex(root);
        updateNavVisibility(root);
        if (defaultStateIndex >= 0) setActiveState(root, defaultStateIndex, { syncSlide: false });
      };

      document.addEventListener('shopify:section:load', (event) => {
        init(event.target);
      });

      return { init, refresh };
    })();
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        window.AnnouncementBarMobilePanels.init();
      },
      { once: true }
    );
  } else {
    window.AnnouncementBarMobilePanels.init();
  }

  if (!window.AnnouncementBarSchedule) {
    // Slides with "Show from" / "Hide from" dates get [hidden] from assets/campaign-schedule.js.
    // Keep the slider, slide labels and arrows in step with the slides that are actually shown.
    window.AnnouncementBarSchedule = (() => {
      const isScheduled = (slide) =>
        slide.hasAttribute('data-campaign-from') || slide.hasAttribute('data-campaign-until');

      const sync = (root) => {
        const slideshow = root.querySelector('slideshow-component');
        if (!slideshow) return;

        const slides = Array.from(slideshow.querySelectorAll('.slideshow__slide'));
        if (!slides.some(isScheduled)) return;

        const shown = slides.filter((slide) => !slide.hidden);
        shown.forEach((slide, index) => {
          const label = slide.getAttribute('aria-label') || '';
          slide.setAttribute('aria-label', label.replace(/^\d+/, index + 1).replace(/\d+$/, shown.length));
        });

        // Nothing left to show: drop the slider, and the whole bar unless the utility tray is there.
        slideshow.style.display = shown.length ? '' : 'none';
        root.style.display = shown.length || root.querySelector('.announcement-bar-shell__utility') ? '' : 'none';

        // SlideshowComponent counts every slide for looping and autoplay; give it the shown ones only.
        if (shown.length && typeof slideshow.initPages === 'function') {
          slideshow.sliderItems = shown;
          slideshow.sliderFirstItemNode = shown[0];
          slideshow.initPages();
        }

        if (window.AnnouncementBarMobilePanels) window.AnnouncementBarMobilePanels.refresh(root);
      };

      const init = (root = document) => {
        root.querySelectorAll('.announcement-bar-shell').forEach(sync);
      };

      document.addEventListener('campaign:changed', () => init());

      return { init };
    })();
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        window.AnnouncementBarSchedule.init();
      },
      { once: true }
    );
  } else {
    window.AnnouncementBarSchedule.init();
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  const initializeTransparentHeaderOffset = () => {
    const transparentHeaderWrapper = document.querySelector('.header-wrapper--transparent');
    if (!transparentHeaderWrapper) return;

    const transparentHeaderSection = transparentHeaderWrapper.closest('.section-header');
    if (!transparentHeaderSection) return;
    const transparentHeaderContainer = transparentHeaderWrapper.parentElement;

    const updateTransparentHeaderOffset = () => {
      transparentHeaderSection.style.setProperty(
        '--header-transparent-offset',
        `${transparentHeaderWrapper.offsetHeight}px`
      );
    };

    updateTransparentHeaderOffset();

    if (window.ResizeObserver) {
      const transparentHeaderObserver = new ResizeObserver(updateTransparentHeaderOffset);
      transparentHeaderObserver.observe(transparentHeaderWrapper);
    } else {
      window.addEventListener('resize', updateTransparentHeaderOffset);
    }

    if (!transparentHeaderContainer || transparentHeaderContainer.tagName.toLowerCase() !== 'sticky-header') {
      const syncTransparentHeaderScrollState = () => {
        if (window.scrollY > transparentHeaderWrapper.offsetHeight) {
          transparentHeaderSection.classList.add('scrolled-past-header');
        } else {
          transparentHeaderSection.classList.remove('scrolled-past-header');
        }
      };

      syncTransparentHeaderScrollState();
      window.addEventListener('scroll', syncTransparentHeaderScrollState, { passive: true });
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeTransparentHeaderOffset, { once: true });
  } else {
    initializeTransparentHeaderOffset();
  }

  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
